import Hunt from 'huntjs';

export const SetupInViewDetection = () => {
  const els = document.querySelectorAll('.-detect-in-viewport');
  new Hunt(els, {
    enter: (el) => {
      el.classList.add('-in-viewport');
      if (el.classList.contains('animate__animated')) {
        el.classList.add('-start-animation');
      }
    },
  });
};